jQuery           = require 'jquery'
_                = require 'lodash'

ubBanzai          = require 'ub/control/banzai-features'
ajaxAsObservable  = require 'ub/control/ajax-as-observable'
endpoints         = require('ub/config/endpoints').default

class PageRepublisher

  constructor: (@uiBinding, @pagePublishObs) ->
    @republishTimeoutPeriod = ubBanzai.getFeatureValue 'republishTimeoutPeriod'
    @republishErrorRetryAttempts = ubBanzai.getFeatureValue 'republishErrorRetryAttempts'

    @uiBinding
      .filterByEventType 'requestRepublish'
      .subscribe =>
        @republish()
        @pagePublishObs.onNext type: 'requestRepublish'

  republish: ->
    page                = window.editor.mainPage
    companyId           = window.editor.currentCompanyId
    pageUUID            = page.uuid
    webappPagesResource = page.getConfigValue('webappPagesResource')
    url                 = endpoints.publish(webappPagesResource, companyId, pageUUID)

    ajaxAsObservable({
      type: 'POST',
      url,
      contentType: 'application/x-www-form-urlencoded'
      data: jQuery.param
        'authenticity_token' : jQuery('meta[name=csrf-token]').attr('content') or ''
        '_method'            : 'put'
    })
    .timeout @republishTimeoutPeriod
    .retry @republishErrorRetryAttempts
    .subscribe _.noop, @onPublishInitError, @onPublishInitComplete

  onPublishInitError: (error) =>
    if ubBanzai.features.isDebugModeEnabled()
      console.warn 'PageRepublisher', 'AJAX error:', error
    @pagePublishObs.onNext type: 'republishError'

  onPublishInitComplete: =>
    @pagePublishObs.onNext type: 'republishInitiated'

module.exports = PageRepublisher



// WEBPACK FOOTER //
// ./src/lp/editor/page-republisher.coffee